import { createLazyFileRoute } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { LoadingPage } from "@/components/LoadingPage";
import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { MasterInvoicePreview } from "@/features/admin/components/billing/MasterInvoicePreview";
import { Section } from "@/features/admin/components/Section";

export const Route = createLazyFileRoute(
  "/_auth/admin/billing/master-invoices/preview",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isPending } =
    trpc.admin.billing.getPreviewMasterInvoice.useQuery();

  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb
              href={{ to: "/admin/billing", search: { t: "master-invoices" } }}
            >
              Billing
            </Breadcrumb>
            <Breadcrumb>Master Invoice Preview</Breadcrumb>
          </>
        }
      >
        Master Invoice Preview
      </Section.Title>
      {isPending ? (
        <LoadingPage />
      ) : (
        <MasterInvoicePreview
          data={
            data ? { lineItems: data.lineItems, total: data.total } : undefined
          }
          isPreview
        />
      )}
    </>
  );
}
